import { useState } from "react"

import { FindCertificatesKpiQueryResponse } from "~/gen/api"
import { DocumentsKPIView } from "~/pages/Brand/Home/components/DocumentsKPI/DocumentsKPI.view.tsx"

type Props = {
  data: FindCertificatesKpiQueryResponse
}

export function DocumentsKPIContainer({ data }: Props) {
  const [certificateType, setCertificateType] = useState<string | null>(null)

  const filteredData = data.filter(
    (certificate) =>
      certificate.certificateType === certificateType || !certificateType
  )

  const certificateTypes = Array.from(
    new Set(data.map((certificate) => certificate.certificateType))
  )

  const countValidatedCertificate = filteredData.filter(
    (certificate) => certificate.status === "PROCESSED"
  ).length
  const countCollectedCertificate = filteredData.filter(
    (certificate) => certificate.status === "PENDING"
  ).length

  const validatedPercent = Math.round(
    (countValidatedCertificate /
      (countCollectedCertificate + countValidatedCertificate)) *
      100
  )
  const collectedPercent = Math.round(
    (countCollectedCertificate /
      (countCollectedCertificate + countValidatedCertificate)) *
      100
  )

  return (
    <DocumentsKPIView
      certificateTypes={certificateTypes}
      setCertificateType={setCertificateType}
      countValidatedCertificate={countValidatedCertificate}
      countCollectedCertificate={countCollectedCertificate}
      validatedPercent={validatedPercent}
      collectedPercent={collectedPercent}
    />
  )
}
